import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`notifications?${params}`);
  },
  read(data) {
    return api.post(`notifications/${data.id}`, data);
  },
  delete(id) {
    return api.delete(`notifications/${id}`);
  },
  getById(id) {
    return api.get(`leave-application/${id}`);
  },
};
